<template>
  <div class="row">
    <div class="col-12">
      <page-header />
      <div class="row">
        <div class="col-12 main-content">
          <data-table
            v-model="table"
            :get-page="getPage"
            :per-page="250"
            :selectable-rows="false"
          >
            <template v-slot:cell(createdAt)="row">
              {{ row.item.createdAt | formatDate('DD.MM.YY HH:mm') }}
            </template>
            <template v-slot:cell(price1)="row">
              {{ row.item.price1 | formatPrice }}
            </template>
            <template v-slot:cell(price2)="row">
              {{ row.item.price2 | formatPrice }}
            </template>
            <template v-slot:cell(price3)="row">
              {{ row.item.price3 | formatPrice }}
            </template>
            <template v-slot:head(company)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.company" />
            </template>
            <template v-slot:head(priceList)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.priceList" />
            </template>
            <template v-slot:head(articleId)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.articleId" />
            </template>
            <template v-slot:head(currency)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.currency" />
            </template>
            <template v-slot:head(ZuAbArt_1)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.ZuAbArt_1" />
            </template>
            <template v-slot:head(ZuAbSchlag_1)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.ZuAbSchlag_1" />
            </template>
            <template v-slot:head(ZuAbArt_2)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.ZuAbArt_2" />
            </template>
            <template v-slot:head(ZuAbSchlag_2)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.ZuAbSchlag_2" />
            </template>
          </data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '../../table/data-table';
import {NotificationMixin, PriceListMixin} from '../../../mixins';
import PageHeader from '../../structure/page-header';
import TableFilter from '../../table/table-filter';

export default {
  name: 'PriceList',
  components: {PageHeader, DataTable, TableFilter},
  mixins: [NotificationMixin, PriceListMixin],
  data: function () {
    return {
      table: {
        selectedRow: null,
        rows: [],
        fields: [
          { key: 'company', label: this.$translate('company'), thClass: 'w100', tdClass: 'w100', sortable: true },
          { key: 'priceList', label: this.$translate('price_list'), thClass: 'w100', tdClass: 'w100', sortable: true },
          { key: 'articleId', label: this.$translate('article'), thClass: 'w100', tdClass: 'w100', sortable: true },
          { key: 'price1', label: `${this.$translate('price')} 1`, thClass: 'w100', tdClass: 'w100', sortable: true },
          { key: 'price2', label:`${this.$translate('price')} 2`, thClass: 'w100', tdClass: 'w100', sortable: true },
          { key: 'price3', label: `${this.$translate('price')} 3`, thClass: 'w100', tdClass: 'w100', sortable: true },
          { key: 'price4', label: `${this.$translate('price')} 4`, thClass: 'w100', tdClass: 'w100', sortable: true },
          { key: 'maxDiscount', label: this.$translate('max_discount'), thClass: 'w150', tdClass: 'w150', sortable: true },
          { key: 'dateTo', label: this.$translate('date_to'), thClass: 'w100', tdClass: 'w100', sortable: true },
          { key: 'currency', label: this.$translate('currency'), thClass: 'w150', tdClass: 'w150', sortable: true },
          { key: 'ZuAbArt_1', label: 'ZuAbArt_1', thClass: 'w150', tdClass: 'w150', sortable: true },
          { key: 'ZuAbSchlag_1', label: 'ZuAbSchlag_1', thClass: 'w150', tdClass: 'w150', sortable: true },
          { key: 'ZuAbArt_2', label: 'ZuAbArt_2', thClass: 'w150', tdClass: 'w150', sortable: true },
          { key: 'ZuAbSchlag_2', label: 'ZuAbSchlag_2', thClass: 'w150', tdClass: 'w150', sortable: true },
          { key: 'createdAt', label: this.$translate('created_date'), thClass: 'w150', tdClass: 'w150', sortable: true },
        ],
        filter: {
          company: null,
          priceList: null,
          articleId: null,
          currency: null,
          ZuAbArt_1: null,
          ZuAbSchlag_1: null,
          ZuAbArt_2: null,
          ZuAbSchlag_2: null,
        },
        sortBy: 'priceList'
      }
    };
  },
  methods: {
    async getPage(ctx) {
      try {
        const response = await this.priceListService.getPage(ctx);
        return {totalCount: response.totalCount, data: response.priceList};
      } catch (err) {
        this.showNotification({type: 'error', message: err.message});
      }
    }
  }
};
</script>

<style scoped lang="scss">
    ::v-deep   .b-table-sticky-header {
      max-height: calc(100vh - 200px);
      min-height: calc(100vh - 200px);
    }

    ::v-deep   .main-content {
      padding: 0;
    }

    ::v-deep   .table {
        min-width: 1200px;
        overflow: scroll;

       td, th {
         word-break: break-word;
          &.w50 {
            width: 50px;
          }
          &.w100 {
            width: 100px;
          }
          &.w150 {
            width: 150px;
          }
          &.w200 {
            width: 200px;
          }
          &.center {
            text-align: center;
          }
        }
    }

    // @media (max-width: 991px) {
    //   .main-content {
    //     max-height: calc(100vh - 100px);
    //   }
    // }
</style>
